<template xmlns="http://www.w3.org/1999/html">
    <div class="video-content">
        <div class="mobile-view" :class="[video.orientation]">
            <div class="mobile-content" v-if="video.video.media !== ''">
                <video :controls="video.show_controls" :autoplay="video.autostart" :muted="true" :class="[video.fit, video.subtype]" :loop="video.end_action === 'loop'">
                    <source :src="video.video.media" />
                </video>
            </div>
        </div>
    </div>
</template>

<script>
import {video} from "@/class/video/video";

export default {
    name: "Video_Content",
    props:{
        video:{type:Object, default:() => new video()}
    },
}
</script>